module.exports = {
	"START_AUTOSCROLL": "Start autoscroll",
	"STOP_AUTOSCROLL": "Stop autoscroll",
	"CHANGE_MATCH": "Change match",
	"MATCH_ID": "Match ID",
	"MATCH_RESULTS": "Match results",
	"MOBILE_SCORING_ROUND_1_OPEN": "Allow score from mobiles ( Round 1 )",
	"MOBILE_SCORING_ROUND_2_OPEN": "Allow score from mobiles ( Round 2 )",
	"ADD_SHOTS_VISUAL": "Target shots visual update",
	"TARGET_TWO": "Target #2",
	"DIRECTION": "Direction",
	"NO": "No",
	"YES": "Yes",
	"FRONT": "Front",
	"BACK": "Back",
	"CREATED_AT": "Created at",
	"UPDATED_AT": "Updated at",
	"DELETE_TRAINING_ENTRY": "Delete training entry?",
	"AVAILABLE": "Available",
	"NOT_AVAILABLE": "Not available",
	"SELECT_PLAYER": "Choose athlete",
	"SELECT_TARGET": "Choose target",
	"SELECT_LEAGUE": "Choose league",
	"SELECT_LEAGUES": "Choose leagues",
	"SELECT_MATCH": "Choose match",
	"SELECT_TEAM": "Choose team",
	"SELECT_SEX": "Choose sex",
	"SELECT_PAYMENT": "Choose payment",
	"PLAYERS_PER_TARGET": "Athletes per target",
	"MATCH_ENTRIES_LIMIT": "Match entries limit",
	"UPDATE_PLAYER_LEAGUE": "Update athlete league",
	"REGISTRATIONS": "Registrations",
	"REGISTRATION_OPEN": "Registration open",
	"REGISTRATION_CLOSED": "Registration closed",
	"MOVE_MATCH": "Move to match",
	"NEW_MATCH": "Match to move",
	"LEAGUES_LIST": "Registrations by league",
	"PLAYERS_LIST": "Registrations by athlete",
	"TEAMS_LIST": "Registrations by team",
	"TARGETS_LIST": "Registrations by targets",
	"QUALIFICATION": "Qualification",
	"QR": "QR",
	"MEDALS": "Medals",
	"PRINTS": "Prints",
	"DOWNLOAD": "Download",
	"ELIMINATION_ROUNDS": "Elimination Rounds",
	"ELIMINATION_INDIVIDUAL": "Individual",
	"ELIMINATION_TEAM": "Team",
	"ELIMINATION_MIXED_TEAM": "Mixed Team",
	"ELIMINATION_PARTICIPANTS": "Participants",
	"SELECT_ELIMINATION_PARTICIPANTS": "Select participants",
	"NEXT_ROUND": "Next round",
	"PRINT_PDF": "Print",
	"STARTING_ROUND": "Starting round",
	"CURRENT_ROUND": "Current round",
	"ADD_ELIMINATION_LEAGUE": "Add league",
	"ELIMINATION_INDIVIDUAL_LEAGUES": "Elimination individual leagues",
	"ELIMINATION_TEAM_LEAGUES": "Elimination team leagues",
	"ELIMINATION_MIXED_TEAM_LEAGUES": "Elimination mixed team leagues",
	"CREATE": "Create",
	"PLAYER_ONE": "Athlete #1",
	"PLAYER_TWO": "Athlete #2",
	"PLAYER_THREE": "Athlete #3",
	"UPDATE_TEAM_LEAGUE_PLAYERS": "Update team league players",
	"FINALIZE_ROUND_ONE": "Finalize round 1",
	"FINALIZE_ROUND_TWO": "Finalize round 2",
	"FINALIZE_MATCH": "Finalize match",
	"TARGETS_WITH_EMPTY_SHOTS": "Targets with missing shots",
	"MALE": "Male",
	"FEMALE": "Female",
	"PLAYER_PAYMENTS_FULFILLMENT": "Athlete payment fulfillments",
	"REMOVE": "Remove",
	"ADD": "Add",
	"ADD_PLAYER_TO_MATCH": "Add athlete to match",
	"CURRENT_PLAYERS": "Current athletes",
	"MATCH_ELIGIBILITY_EXPLAIN_TEXT": "You cannot register the athlete for this match for the following reasons:",
	"PRINT_REGISTRATIONS_PDF": "Print registrations",
	"REGISTRATION_IS_CLOSED": "Registrations are closed.",
	"ADD_SHOTS": "Add shots",
	"ROUND_ONE": "Round 1",
	"ROUND_TWO": "Round 2",
	"CLEAR_ROUND": "Clear round shots",
	"FINAl_SCORES_ROW": "Final scores",
	"ADD_SHOTS_INDIVIDUAL": "Add shots individuals",
	"REQUIRED_BY_TEAM": "Required by team",
	"REQUIRED_BY_PLAYER": "Required by athlete",
	"ADD_NEW_PAYMENT": "Add new payment",
	"ADD_TEAM_PAYMENT": "Add new team payment",
	"ADD_PLAYER_PAYMENT": "Add new athlete payment",
	"PAYMENT": "Payment",
	"AMOUNT": "Amount",
	"STAFF": "Staff",
	"EDIT_STAFF": "Edit staff",
	"STAFF_PROFILE": "Staff profile",
	"SELECT_ROUND": "Select round",
	"FINAL_SHOT": "S.O.",
	"ADD_SHOTS_TEAM": "Add shots team",
	"ADD_SHOTS_MIXED_TEAM": "Add shots mixed team",
	"MATCH_NAME": "Match name",
	"MATCH_SORT_NAME": "Sort name",
	"MATCH_HOST": "Host",
	"MATCH_JUDGE": "Judges",
	"MATCH_REPRESENTER": "Represented",
	"MATCH_COMMITTEE": "Committee",
	"MATCH_OFFICIAL": "Official",
	"MATCH_LOCATION": "Location",
	"MATCH_CUP": "Cup",
	"MATCH_CHAMPIONSHIP": "Championship",
	"MATCH_TYPE": "Type",
	"MATCH_LEAGUES": "Leagues",
	"LEAGUE_CAT": "League category",
	"EXIT_GAME": "Exit",
	"MATCH_REGISTRATION_START": "Registration Open Date",
	"MATCH_REGISTRATION_END": "Registration Close date",
	"EDIT_MATCH": "Edit match",
	"LEAGUE_TYPE": "Type",
	"LEAGUE_SEX": "Sex",
	"LEAGUE_ELIMINATIONS_ELIGIBILITY": "Elimination rounds",
	"DISTANCE_INDOOR": "Indoor distance",
	"DISTANCE_OUTDOOR": "Outdoor distance",
	"LEAGUE_SORT_NAME": "Sort name",
	"LEAGUE_CODE": "Code",
	"LEAGUE_ORDER": "Order",
	"EDIT_LEAGUE": "Edit league",
	"SCHOOL": "School",
	"AGE": "Age ( equal or greater )",
	"CREATE_LEAGUE": "Create league",
	"CREATE_MATCH": "Create match",
	"PICK": "Pick",
	"DOWNLOAD_CARD": "Card",
	"DOWNLOAD_TRAINING_CARD": "Training card",
	"TRAINING_ENTRIES": "Training entries",
	"ENDED": "Ended",
	"PAUSED": "Paused",
	"PAUSE": "Pause",
	"UNPAUSE": "Unpause",
	"END": "End",
	"START": "Start",
	"START_ENTRY": "Start",
	"PAUSE_TRAINING_ENTRY": "Are you sure you want to pause the entry?",
	"END_TRAINING_ENTRY": "Are you sure you want to end the entry?",
	"UNPAUSE_TRAINING_ENTRY": "Are you sure you want to un-pause the entry?",
	"ADD_TRAINING_ENTRIES": "Add training entries",
	"START_TRAINING_ENTRY": "Are you sure you want to use the entry?",
	"TRAINING_CENTER": "Training center",
	"OAKA_TRAINING_CENTER": "Training center",
	"CURRENT_ACTIVE_INSIDE": "Currently inside training center",
	"INFORMATION": "Information",
	"SORT_NAME": "Sort name",
	"POSTAL_CODE": "P.C.",
	"VAT": "VAT",
	"OFFICIAL": "Official",
	"IMAGE": "Image",
	"SELECT_FILE": "Choose file",
	"MAP_LOCATION": "Location",
	"CREATE_TEAM": "Create team",
	"SELECT_YEAR": "Select year",
	"SELECT_STATE": "Select state",
	"SELECT_COUNTY": "Select county",
	"SELECT_REGION": "Select region",
	"GO_TO_PROFILE": "Profile",
	"MATCHES": "Matches",
	"REPORTS": "Reports",
	"PAYMENTS": "Payments",
	"PAYMENT_ITEMS": "Payments",
	"TEAM_PAYMENTS": "Team payments",
	"MENU": "Menu",
	"DASHBOARD": "Dashboard",
	"LOGOUT": "Logout",
	"SELECT": "Select",
	"ACTIONS": "Actions",
	"ABOUT": "About",
	"TEAM_PROFILE": "Team profile",
	"FILTERS": "Filters",
	"TEAM_PAYMENTS_LIST": "Team payments",
	"PLAYER_PAYMENTS_LIST": "Athlete payments",
	"DATE_FROM": "Date from",
	"DATE_TO": "Date to",
	"EDIT_TEAM_PAYMENT": "Edit team payment",
	"EDIT_PLAYER_PAYMENT": "Edit athlete payment",
	"PRINT_RESULTS": "Print results",
	"SELECT_NATIONALITY": "Select nationality",
	"SELECT_CITIZENSHIP": "Select citizenship",
	"BIRTH_DATE": "Birthdate",
	"ACTIVE": "Active",
	"FATHER": "Father",
	"MOTHER": "Mother",
	"PLAYER_PROFILE": "Athlete profile",
	"PLAYER_PAYMENT_REPORT": "Athlete payment report",
	"TRANSFER_PLAYER": "Athlete transfer",
	"SELECT_NEW_TEAM": "Select new team",
	"NEW_TRANSFER_PLAYER": "New athlete transfer",
	"EDIT_TRANSFER_PLAYER": "Edit athlete transfer",
	"OLD_TEAM": "Old team",
	"NEW_TEAM": "New team",
	"OLD_HEALTH_SORT": "Old health number",
	"NEW_HEALTH_SORT": "New health number",
	"ERROR": "Something went wrong...",
	"ENTER": "Enter",
	"CONFIRM": "Confirm",
	"CONFIRM_DELETE_TEAM": "Are you sure you want to delete this team?",
	"CONFIRM_DELETE_PLAYER": "Are you sure you want to delete this athlete?",
	"CONFIRM_DELETE_LEAGUE": "Are you sure you want to delete this league?",
	"CONFIRM_DELETE_MATCH": "Are you sure you want to delete this match?",
	"CONFIRM_DELETE_PAYMENT": "Are you sure you want to delete this payment?",
	"CONFIRM_CLEAR_TARGETS": "Are you sure you want to clear the targets?",
	"CONFIRM_REMOVE_LEAGUE_FROM_MATCH": "Are you sure you want to remove this league from the match?",
	"CONFIRM_MOVE_LEAGUES": "Are you sure you want to move these leagues?",
	"CONFIRM_DELETE_ELIMINATION_MATCH": "Are you sure you want to delete this elimination match?",
	"CONFIRM_REMOVE_PLAYER_FROM_MATCH": "Are you sure you want to remove this athlete from the match?",
	"CHANGE_TEAM_PASSWORD": "Change team password",
	"CHANGE_PASSWORD": "Change password",
	"NEW_PASSWORD": "New password",
	"NEW_PASSWORD_CONFIRMATION": "New password (confirm)",
	"AUTHORIZATION_KEY": "Authorization key",
	"ROLES": "Roles",
	"DISPLAY_NAME": "Name",
	"DESCRIPTION": "Description",
	"EDIT_ROLE": "Edit role",
	"CREATE_ROLE": "New role",
	"SELECT_PERMISSIONS": "Select permissions",
	"USERS": "Users",
	"EDIT_USER": "Edit user",
	"CREATE_USER": "New user",
	"SELECT_ROLE": "Select role",
	"ROLE": "Role",
	"CHANGE_USER_PASSWORD": "Change user password",
	"WELCOME_TO": "Welcome to ",
	"ADD_REMOVE_PLAYERS": "Add/remove athletes",
	"CREATE_PLAYER": "Add athlete",
	"LOAD_ALL_PLAYERS": "All athletes",
	"SIGN_IN": "Sign in",
	"USER": "User",
	"YOUR_EMAIL": "Your email",
	"RETURN_TO": "Return to ",
	"FORGOT_YOUR_PASSWORD": "Forgot your password?",
	"FORGOT_PASSWORD_ENTER_EMAIL": "Enter your email and we'll forward an email with instructions.",
	"RECOVER_SUCCESS": "If the user is found an email will be sent.",
	"RESET_PASSWORD": "New password",
	"LOAD_FINANCIAL_OK_PLAYERS": "Active athletes ( Financial OK )",
	"AD_BLOCK_MESSAGE": "Please for the correct usage disable the ad blocker in your browser.",
	"CONTRACT_DATE": "Contract expiration date",
	"HAS_COACH": "Have coach?",
	"TARGETS_BOARDS": "Target boards",
	"JUDGES": "Judges",
	"EDIT_JUDGE": "Edit judge",
	"CREATE_JUDGE": "Add judge",
	"JUDGE_PROFILE": "Judge profile",
	"CONFIRM_DELETE_JUDGE": "Are you sure you want to delete this judge?",
	"SELECT_JUDGES": "Select judges",
	"COACHES": "Coaches",
	"EDIT_COACH": "Edit coach",
	"CREATE_COACH": "Add coach",
	"COACH_PROFILE": "Coach profile",
	"CONFIRM_DELETE_COACH": "Are you sure you want to delete this coach?",
	"TRAINERS": "Part-time Trainers",
	"EDIT_TRAINER": "Edit part-time trainer",
	"CREATE_TRAINER": "Add part-time trainer",
	"TRAINER_PROFILE": "Part-time Trainer profile",
	"CONFIRM_DELETE_TRAINER": "Are you sure you want to delete this part-time trainer?",
	"PRINT_GAME_PDF": "Print qualification",
	"PRINT_GAME_PDF_AFTER_GAME": "Print qualification",
	"PRINT_GAME_PLAYERS_PDF": "Print athletes",
	"PRINT": "Prints",
	"GAME_LOGOUT": "Exit match",
	"LIMBS": "Limbs",
	"RISER": "Riser",
	"ARROWS": "Arrows",
	"EQUIPMENT": "Equipment",
	"FROM": "From",
	"POSITION": "Position",
	"ADD_SHOTS_TO_GAME": "Add shots to match",
	"HOST": "Host",
	"SEARCH_GAME_NAME": "Search...",
	"SORT_LEAGUE_NAME": "Sort name",
	"SEARCH_LEAGUE_NAME": "Search...",
	"ADD_PLAYERS_TO_TEAM": "Add athletes to team",
	"PLAYER": "Athlete",
	"USERNAME": "Username",
	"PASSWORD": "Password",
	"SEARCH_TEAM_NAME": "Search...",
	"PROFILE": "Profile",
	"LIST_PLAYERS": "List athletes",
	"LIST_TEAMS": "List teams",
	"LIST_GAMES": "List matches",
	"LIST_LEAGUES": "List leagues",
	"INDEX": "Homepage",
	"C": "C",
	"SUBMIT": "Submit",
	"SUBMIT_NEXT": "Submit and next target",
	"SUBMIT_EXIT": "Submit and exit",
	"ERROR_MONKEYS": "Oops, something went wrong",
	"SUCCESS": "Success",
	"EXISTS": "Already exists",
	"ROUND_1": "Round 1",
	"ROUND_2": "Round 2",
	"PLAYERS": "Athletes",
	"ADD_PLAYER": "Add athlete",
	"EDIT_PLAYER": "Edit athlete",
	"DELETE_PLAYER": "Delete athlete",
	"TEAMS": "Teams",
	"ADD_TEAM": "Add team",
	"EDIT_TEAM": "Edit team",
	"DELETE_TEAM": "Delete team",
	"GAME": "Match",
	"ADD_GAME": "Add match",
	"EDIT_GAME_LEAGUES": "Edit match leagues",
	"EDIT_GAME": "Edit match",
	"DELETE_GAME": "Delete match",
	"ADD_PLAYERS_TO_MATCH": "Add athletes to match",
	"REMOVE_PLAYERS_FROM_MATCH": "Remove athletes from match",
	"ADD_SHOTS_P1": "Add shots",
	"ADD_SHOTS_P2": "Add shots",
	"ADD_SHOTS_P3": "Add shots",
	"UPDATE_GAME": "Update match",
	"ADD_LEAGUE": "Add league",
	"REMOVE_LEAGUE": "Remove league",
	"DELETE_LEAGUE": "Delete league",
	"STATS": "Stats",
	"GAME_STATS": "Match stats",
	"STATS_FOR_TEAM": "Team stats",
	"STATS_FOR_PLAYER": "Athlete stats",
	"LIVESCORES": "Live scores",
	"MENU_SETTINGS": "Menu Settings",
	"OVERVIEW": "Match overview",
	"OLYMPIC": "Elimination Rounds",
	"ADD_OLYMPIC_SHOTS": "Add elimination round shots",
	"EDIT_GAME_LEAGUES_PLAYERS": "Edit athlete league for match",
	"PICK_LEAGUE_DEL": "Select league to delete",
	"PICK_LEAGUE_ADD": "Select league to add",
	"TRUELIVE_ALL": "Results",
	"TRUELIVE_CAT": "Results",
	"PRINT_GAME_PDF_MEDALS": "Print Medals",
	"PRINT_GAME_PDF_MEDALS_OLYMPIC": "Print Medals",
	"SELECT_ALL": "Select all",
	"CHECK_THIS_FOR_ALL": "Check this for all leagues",
	"GO_BACK": "Go back",
	"FXs": "Total Xs",
	"ROUNDS": "Rounds",
	"FINAL_SCORES": "Final scores",
	"PLAYER/ER": "Athlete",
	"O/I": "",
	"EMPTY_SHOTS": "has empty shots on target ",
	"PRINT_GAME_DETAILS": "Print match details",
	"NUMBER": "#",
	"PRINT_GAME_PLAYERS": "Print match athletes",
	"ALPHA_LIST_GAME": "Print match athletes with targets",
	"PRINT_GAME_TARGETS": "Print targets",
	"ALL_TARGETS": "All targets",
	"PRINT_GAME_PLAYERS_TEAMS": "Print athletes by team",
	"MONEY_CHECK": "Check",
	"LIST_BY_TEAM": "Athletes by team",
	"PDF_RIGHTS": "*Careful, results might be different from actual shots",
	"GREEK": "Greek",
	"GAME_RESULTS": "Personal Match Results",
	"MRS": "Dear Mr/Ms",
	"HERE_ARE": "Here are the results of the competition you took place in ",
	"HERE_ARE_TEAM": "Here are the results of the competition your club took place in ",
	"CUSTOM": "Custom",
	"ARROW_NOW": "Arrow No",
	"SETTINGS": "Settings",
	"DEGREE_SETTINGS": "Degree Settings",
	"FIELD_1": "Field 1",
	"FIELD_2": "Field 2",
	"FIELD_3": "Field 3",
	"PRINT_DEGREES": "Print Degrees",
	"NO_FOR_OLYMPIC": "Number of athletes for elimination round",
	"SUGGESTED": "suggested",
	"THERE_ARE_TOTAL": "Total ",
	"EXPORT_GAME": "Export match",
	"ONE_PLAYER": "One athlete",
	"ALL_PLAYERS": "All athletes",
	"ADD_WITH_FILE": "Add with file",
	"ADD_WITH_DETAILS": "Add with details",
	"ADD_WITHOUT_DETAILS": "Add without details",
	"IMPORT_GAME": "Import match",
	"TEAM_SORT_NAME": "Sort name",
	"TEAM_S_NAME": "Team",
	"SEND_PLAYER_EMAILS": "Email Athletes",
	"ABOUT_ME": "About me",
	"INFO": "Information",
	"FOR": "for",
	"BIRTHDATE": "Birthdate",
	"GAME_HISTORY": "Match history",
	"SEND_MESSAGE": "Send message",
	"FILE_EXPLORER": "Files",
	"COACH_OF": "coach of ",
	"RECURVE": "Recurve",
	"RECURVE_M_W": "Recurve Men - Women",
	"RECURVE_YM_YW": "Recurve Cadet Men - Women",
	"RECURVE_JM_JW": "Recurve Junior Men - Women",
	"COMPOUND": "Compound",
	"COMPOUND_M_W": "Compound Men - Women",
	"COMPOUND_YM_YW": "Compound Cadet Men - Women",
	"COMPOUND_JM_JW": "Compound Junior Men - Women",
	"TEENS": "Boys",
	"NEANIDWN": "Girls",
	"NO_RESULTS": "No results found",
	"INDIVIDUAL_OLYMPIC": "Individual elimination rounds",
	"TEAM_OLYMPIC": "Team elimination rounds",
	"NO_FOR_OLYMPIC_TEAMS": "# of teams for elimination rounds",
	"PICK_CATEGORY": "Select league",
	"NOT_ENOUGH_PLAYERS": "Team does not have enough athletes to participate",
	"PLAYER_1": "Athlete 1",
	"PLAYER_2": "Athlete 2",
	"PLAYER_3": "Athlete 3",
	"MIXED_TEAM_OLYMPIC": "Mixed Team elimination rounds",
	"OL_TEAM": "Team",
	"FINAL": "Final",
	"PRINT_GAME_BOOK": "Print match book",
	"MEDALS_FROM_QUALIFICATIONS": "Medals from qualification",
	"MEDALS_FROM_OLYMPIC": "Medals from elimination rounds",
	"MEDAL": "Medal",
	"GOLD": "Gold",
	"SILVER": "Silver",
	"BRONZE": "Bronze",
	"ENTRIES_BY_TEAM": "Registrations by team",
	"OLYMPIC_ROUNDS_INDIVIDUAL": "Individual eliminations",
	"QUALIFICATION_INDIVIDUAL": "Qualification individuals",
	"OLYMPIC_ROUNDS_TEAM": "Team eliminations",
	"QUALIFICATION_TEAM": "Qualifications team",
	"MIXED_TEAM": "Mixed Team",
	"INDIVIDUAL": "Individual",
	"PRINT_OLYMPIC_ROUNDS": "Print elimination rounds",
	"MIXED": "Mixed",
	"ADD_GAME_QUICKSTART": "Add match",
	"TYPE": "Type",
	"DATE_FILED": "Date filed",
	"GGA_NUMBER": "Official number",
	"LEVEL": "Level",
	"COACH_LEVEL": "Coach level",
	"JUDGE_LEVEL": "Judge level",
	"TRAINER_LEVEL": "Part-time Trainer level",
	"COACH_0_LEVEL": "Coach",
	"COACH_A_LEVEL": "A CATEGORY",
	"COACH_B_LEVEL": "B CATEGORY",
	"COACH_C_LEVEL": "C CATEGORY",
	"TRAINER_0_LEVEL": "Part-time Trainer",
	"TRAINER_1_LEVEL": "LEVEL 1",
	"TRAINER_2_LEVEL": "LEVEL 2",
	"TRAINER_3_LEVEL": "LEVEL 3",
	"CL1": "CL1",
	"CL2": "CL2",
	"TEAM_ENTRIES_LIST": "Entries Per Team",
	"ATHLETES_SCORECARDS": "Athletes Scorecards",
	"SELECT_LEVEL": "Select level",
	"JUDGE_STAFF": "Judge",
	"JUDGE_INTERNATIONAL": "International",
	"JUDGE_NATIONAL": "National",
	"JUDGE_CANDIDATE": "Candidate",
	"INDOOR": "Indoor",
	"OUTDOOR": "Outdoor",
	"indoor": "Indoor",
	"outdoor": "Outdoor",
	"GAME_TYPE": "Match type",
	"GAME_DETAILS": "Match details",
	"GAME_LEAGUES": "League details",
	"GREAT": "Great",
	"PREVIOUS": "Previous",
	"NEXT": "Next",
	"BIRTH_PLACE": "Birth place",
	"STATE": "State",
	"CITIZENSHIP": "Citizenship",
	"NATIONALITY": "Nationality",
	"EXPATRIATE": "Expatriate",
	"CITY": "City",
	"ADT": "ADT",
	"PASSPORT": "Passport",
	"HEALTH": "Health Code",
	"AMEA": "Para-Archery",
	"REGISTRATION_DATE": "Registration Date",
	"FULL_NAME": "Full name",
	"NAME": "Name",
	"IDENTIFY_DATE": "Identification date",
	"IDENTIFY_CODE": "Identification code",
	"COUNTY": "County",
	"FAX": "FAX",
	"WEB": "Website",
	"AFM": "VAT",
	"DOY": "VAT Location",
	"COACH_EMAIL": "E-mail Coach",
	"REGION": "Region",
	"CALENDAR": "Calendar",
	"REG_DATE": "Registration Date",
	"LNAME": "Last name",
	"FNAME": "First name",
	"STATUS": "Status",
	"DETAILS": "Details",
	"CLEAR_SHOTS": "Clear shots",
	"SUBMIT_RETURN": "Submit and return",
	"QUALIFICATION_MIXED_TEAM": "Qualification Mixed Team",
	"OLYMPIC_TEAM_MIXED": "Eliminations Mixed Team",
	"EMPTY_ALL_TARGETS": "Clear all targets",
	"PRINT_OLMPIC_LAYOUT": "Print eliminations layout",
	"PRODUCE_TARGETS": "Product Targets",
	"TARGETS_NUMBER": "Number of targets",
	"CHOOSE_PLAYERS": "Select athletes",
	"VIEW_REGISTRATION": "View registrations",
	"LIST_ENTRIES": "List of registrations",
	"DELETE": "Delete",
	"HOW_MANY": "How many?",
	"REGISTRATION_OPEN_DATE": "Registration open date",
	"REGISTRATION_END_DATE": "Registration ending date",
	"CLOSE_REGISTRATION": "Close registrations",
	"PRINT_ENTRIES_PDF": "Print registrations",
	"PRINT_ENTRIES_PDF_SPECIFIC": "Print team registrations",
	"GAME_ENTRIES": "Registrations",
	"NOTES": "Notes",
	"TARGETS": "Targets",
	"TARGET": "Target",
	"PLAYER_LEAGUES": "Athlete leagues",
	"ADD_SHOTS_OLYMPIC": "Add elimination round shots",
	"ADD_PLAYERS": "Add athletes",
	"REMOVE_PLAYERS": "Remove athletes",
	"PLAYERS_REGISTERD": "Athletes registrations",
	"EDIT_PERMISSIONS": "Edit permissions",
	"USER_ROLE": "Role",
	"EDIT_ROLES": "Edit roles",
	"CLOSED": "CLOSED",
	"OPEN": "OPEN",
	"REGISTRATION_STATUS": "Registration status is ",
	"REGISTRAION_CLOSED_TEXT": "** Registrations are closed. You cannot make any changes. Please contact XXX@XXX.XXX for any requests.",
	"CURRENT_LIST": "Current list",
	"ENTRIES_PDF": "Print registrations",
	"REGISTRATION_CLOSED_TEXT_LIST": "**Below is the list with the athletes that you have registered. The regstraion is now closed. You cannot make any changes. Please contact us for any kind of information you might need.",
	"ENTRIES_PROOF": "** Please print or have this with you at the match",
	"GRATZ_TO": "Congratulations to",
	"COMPETED_IN": "for competing in",
	"NOW_ELIGIBLE": "can now compete in",
	"AFTER_SCOREING": "after shooting",
	"PASSED_LIMIT": "and surpassing",
	"COMPANION": "Companion",
	"SAVE_MATCH_TEAM_INFO": "Save companions",
	"CAPTAIN": "Captain",
	"REQUIRED_FIELDS": "Fields with * are required",
	"PLUGINS": "Plugins",
	"VALIDATE_PASSPORTS": "Validate cards ( current year )",
	"VALIDATE_PASSPORT": "Validate card ( current year )",
	"FINANCIAL": "Financial",
	"ADD_PAYMENT_REASON": "Add payment",
	"PRICE": "Price",
	"COMMENTS": "Comments",
	"ADD_PAYMENT_TEAM": "Team payments",
	"ADD_PAYMENT_PLAYER": "Athlete payments",
	"PAYMENT_REASON": "Payment description",
	"ADD_PAYMENT": "Add payment",
	"REQUIRED_TEAM": "Required by teams to participate in matches",
	"REQUIRED_PLAYER": "Required by athletes to participate in matches",
	"YEAR": "Year",
	"ADD_NEW": "Add new",
	"EDIT_USERS": "Edit users",
	"PAYMENT_REPORT": "Payment report",
	"REPORT_OF_YEAR": "Payment report for year : ",
	"AMOUNT_PAID": "Amount paid",
	"MOVEMENT_REPORT": "Movements report",
	"TEAM_REPORT_NAME": "Name : ",
	"TOTAL_MOVEMENTS": "Total movements : ",
	"TOTAL_AMOUNT_MOVED": "Total amount : ",
	"PAYMENT_DATE": "Movement date",
	"STARTED_DATE": "Time started",
	"ENDED_DATE": "Time ended",
	"CANCEL": "Cancel",
	"PAYMENT_SUCCESSFULL": "Successful",
	"PAYMENT_FAILED": "Payment failed",
	"LIST_PAYMENT_MOVEMENTS_TEAMS": "Team payments",
	"LIST_PAYMENT_MOVEMENTS_PLAYERS": "Athletes payments",
	"EDIT_PAYMENT": "Edit payment",
	"CANCEL_PAYMENT": "Cancel payment",
	"PAYMENT_EDIT_SUCCESSFULL": "Edit was successful",
	"PAYMENT_EDIT_FAIL": "Edit failed",
	"IMPORT_SCORES": "Import scores",
	"PLAYER_PASSPORT": "Athlete passport",
	"VALID": "Valid",
	"NOT_VALID": "Not valid",
	"PAID": "Paid",
	"NOT_PAID": "Not paid",
	"STUDENT": "Student",
	"STUDENT_TEAM": "Student team",
	"NATIONAL": "National",
	"NATIONAL_TEAM": "National team",
	"AMEA_TEAM": "Team Î‘.Îœ.Î•.Î‘",
	"TRANSFERS": "Transfers",
	"TRANSFER": "Transfer",
	"FROM_TEAM": "From ",
	"TO_TEAM": "To ",
	"OLD_HEALTH": "Old passport",
	"NEW_HEALTH": "New passport",
	"TRANSFER_SUCCESSFUL": "Transfer successful",
	"TRANSFER_FAIL": "Transfer failed",
	"NEW_TRANSFER": "New transfer",
	"ALREADY_PAID": "Already paid",
	"ALREADY_EXISTS": "Already exists",
	"FROM_TO_EMPTY_FOR_ALL": "From - To",
	"PAYMENT_REASON_EMPTY_FOR_ALL": "Payment ( blank for all )",
	"PICK_TEAM_EMPTY_FOR_ALL": "Team ( blank for all )",
	"PICK_PLAYER_EMPTY_FOR_ALL": "Athlete ( blank for all )",
	"RESTORE_PAYMENT": "Restore payment",
	"LIST_TRANSFERS": "Transfers",
	"TRANSFER_DATE": "Date of transfer",
	"EDIT_TARGETS": "Edit targets",
	"TOTAL_ENTRIES": "Total entries",
	"UNIQUE_ENTRIES": "Unique entries",
	"PDF": "PDF",
	"MATCH_OVERVIEW": "Match Overview",
	"OFFICIAL_SCORE": "Official score",
	"ENTRIES": "Entries",
	"FORFEITED": "Forfeited/No show",
	"TEAM_INFO": "Team Info",
	"MOVE_GAME": "Move match",
	"MOVE_FRONT": "Move front",
	"MOVE_TARGETS": "Move targets",
	"DISTANCE": "Distance",
	"FROM_TARGET": "From target",
	"TO_TARGET": "To target",
	"MOVE_BACK": "Move back",
	"TOTAL_PLAYERS": "Total athletes",
	"TOP_SCORE_IN_LEAGUE": "Score",
	"TOTAL_ENTRIES_IN_LEAGUE": "Entries",
	"AMS_CODE": "Code",
	"EOT": "Saudi Archery Federation",
	"REPORT_1": "Athletes per Team",
	"REPORT_2": "Teams",
	"REPORT_3": "Registered athletes per team",
	"REPORT_4": "Matches and entries",
	"REPORT_5": "Athletes entries per league",
	"REPORT_6": "Athletes entries per team",
	"REPORT_7": "Athletes scores",
	"REPORT_8": "Most win athletes/teams",
	"REPORT_9": "Training center entries",
	"REPORT_10": "Best shootings per athlete/team/league",
	"REPORT_11": "Athletes #2",
	"REPORT_12": "Teams #2",
	"REPORT_13": "Medals",
	"FOR_YEAR": "For year",
	"SUSPEND_REASON": "Reason",
	"SUSPEND_TEAM": "Suspend Team",
	"TEAM_IS_SUSPENDED": "You cannot register athletes at this moment.",
	"TEAM_IS_SUSPENDED_PROFILE": "This team is suspended.",
	"OVERRIDE_AGE_LIMITS": "Override Age Limits",
	"PLAYER_MATCHES": "Athlete matches",
	"PLAYER_PAYMENTS": "Athlete payments",
	"PASSPORTS": "Passports",
	"START_DATE": "Start date",
	"DAYS_LEFT": "Days left",
	"VALID_UNTIL": "Valid until",
	"DAYS": "days",
	"EXPIRED": "Is expired",
	"ADD_PASSPORT": "Add passport",
	"LIMIT_INDOOR": "Indoor limit",
	"LIMIT_OUTDOOR": "Outdoor limit",
	"OVERRIDE_LIMITS": "Override Limits ( Age & Score )",
	"OVERRIDE_CHECKS": "Override All Check",
	"MATCH_CODE": "Match code",
	"PLAYER_NAME": "Athlete name",
	"FIRST_NAME": "First Name",
	"LAST_NAME": "Last Name",
	"SEX": "Sex",
	"MEN": "Male",
	"WOMEN": "Female",
	"OTHER": "Other",
	"EMAIL": "E-mail",
	"BIRTH": "Birthdate",
	"LEAGUE": "League",
	"TEAM": "Team",
	"EDIT": "Edit",
	"PICK_PLAYER": "Select athlete",
	"FATHER_NAME": "Father name",
	"MOTHER_NAME": "Mother name",
	"CODE": "Code",
	"TEAM_NAME": "Team name",
	"LOCATION": "Location",
	"PICK_TEAM": "Pick team",
	"ADDRESS": "Address",
	"EFOT_REG": "Organization code",
	"PC": "Postal Code",
	"ADMIN": "Admin",
	"COACH": "Coach",
	"PHONE": "Phone",
	"TARGET_FROM": "Targets from",
	"TARGET_TO": "to",
	"GAME_NAME": "Match name",
	"DATE": "Date",
	"LEAGUES": "Leagues",
	"PICK_GAME": "Select match",
	"TARGET_NAME": "Target",
	"ROUND": "Round",
	"PICK_TARGET": "Pick target",
	"SHOT_1": "Shot 1",
	"SHOT_2": "Shot 2",
	"SHOT_3": "Shot 3",
	"SHOT_4": "Shot 4",
	"SHOT_5": "Shot 5",
	"SHOT_6": "Shot 6",
	"SHOT_7": "Shot 7",
	"SHOT_8": "Shot 8",
	"SHOT_9": "Shot 9",
	"SHOT_10": "Shot 10",
	"UPDATE_ROUND_1": "Update Round 1",
	"UPDATE_ROUND_2": "Update Round 2",
	"ARE_YOU_SURE_UPDATE_GAME": "Are you sure you want to update the match?",
	"INFO_GAME": "Match info",
	"JUDGE": "Judges",
	"REPRESENTER": "Represented",
	"COMMITTEE": "Committee",
	"SWAP_PLAYERS": "Swap athletes",
	"MOVE_PLAYER": "Move to target",
	"SWAP_TARGETS": "Swap targets",
	"ORDER_BY": "Sort by",
	"SEARCH_NAME": "Search by athlete",
	"SEARCH_TEAM": "Search by team",
	"PICK_ROUND": "Select round",
	"ARROW": "Arrow",
	"LEAGUE_NAME": "League",
	"CATEGORY": "League",
	"CATEGORY_S": "Leag.",
	"PICK_LEAGUE": "Select league",
	"TOTAL_SCORE": "Total score",
	"SHOT_NOW": "Shot No",
	"TOTAL": "Total",
	"TOTAL/RANK": "Total/ Rank",
	"TOTAL/RANKs": "Total",
	"TOTAL_SCORE_POINTS": "Points",
	"REAL_LIVESCORES": "Live scores",
	"SHOT_NUMBER_NOW": "shot now",
	"SHOT_SCORE_SO_FAR": "Score so far",
	"RANK": "Rank",
	"ROUND_1/RANK": "Round 1/ Rank",
	"ROUND_2/RANK": "Rank 2/ Rank",
	"ROUND_1/RANKs": "R.1",
	"ROUND_2/RANKs": "R.2",
	"10s": "10s",
	"9s": "9s",
	"10ss": "10",
	"9ss": "9",
	"INCREMENT_SCORE": "Increment score",
	"FINAL_SCORE": "Final score",
	"SHOT_SCORE": "Shot score",
	"F10s": "Total 10s",
	"F9s": "Total 9s",
	"STOP_AUTOSCROLLING": "Stop Autoscrolling",
	"TOP_2_PLAYERS": "Best 2 athletes per league",
	"START_AUTOSCREOLLING": "Start Autoscrolling",
	"MATCH_DATE": "Match date",
	"DOWNLOAD_RESULTS": "Download results",
	"UPLOAD_RESULTS_PDF": "Update results",
	"CURRENT_RESULTS_PDF": "Current results",
	"IMPORT_OLD_GAMES": "Import old matches",
	"EXTENSION_ERROR": "File extension is not allowed.",
	"PHOTO_SIZE_ERROR": "Photos up to 2ÎœÎ’",
	"UNKNOWN": "Unknown error on upload.",
	"UPLOAD_FAILED": "Upload failed.",
	"NO_IMAGE": "Select an image first.",
	"ALL_ATHLETES": "All athletes",
	"ACTIVE_ATHLETES": "Active athletes",
	"RECURVE_LEVEL": "Recurve level",
	"COMPOUND_LEVEL": "Compound level",
	"BOW_TYPE": "Bow",
	"MIXED_LEAGUE": "Mixed League",
	"TARGET_BOARDS": "Target Boards",
	"STARTING_FROM_TARGET": "Starting from",
	"trainingCenters": "Training Centers",
	"TITLE": "Title",
	"CREATE_TRAINING_CENTER": "Create training center",
	"EDIT_TRAINING_CENTER": "Edit training center",
	"TRAINING_CENTERS": "Training Centers",
	"CONFIRM_DELETE_TRAINING_CENTER": "Delete training center?",
	"SELECT_TRAINING_CENTER": "Select training center",
	"editRoles": "Edit roles",
	"addPlayer": "Add athlete",
	"editPlayer": "Edit athlete",
	"deletePlayer": "Delete athlete",
	"addTeam": "Add club",
	"editTeam": "Edit club",
	"deleteTeam": "Delete club",
	"addLeague": "Add league",
	"editLeague": "Edit league",
	"deleteLeague": "Delete league",
	"addGame": "Add event",
	"editGame": "Edit event",
	"deleteGame": "Delete event",
	"editGameTargets": "Edit event targets",
	"editGameLeagues": "Edit event leagues",
	"editGamePlayerLeague": "Edit event leagues for athletes",
	"addPlayersToMatch": "Add athletes to event",
	"removePlayersFromMatch": "Remove athletes from event",
	"addShotsToGame": "Add shots to event",
	"gameUpdate": "Update event",
	"olympic": "Elimination Rounds",
	"addShotsToOlympic": "Add shots to elimination rounds",
	"calendar": "Calendar",
	"files": "Files",
	"stats": "Statistics",
	"viewAllPlayers": "View all athletes",
	"viewAllTeams": "View all clubs",
	"viewAllLeagues": "View all leagues",
	"settings": "Settings",
	"livescores": "Livescore",
	"passportValidate": "Update document",
	"viewFinancial": "View Financial Statements",
	"addPaymentReason": "Add payment reason",
	"addPaymentTeam": "Add club payment",
	"addPaymentPlayer": "Add athlete payment",
	"changeTeamPassword": "Change club password",
	"viewAllMovementsTeams": "View all club payments",
	"playerTransfers": "Transfers",
	"viewAllMovementsPlayers": "View all athlete payments",
	"makePlayerTransfer": "Add-Edit athlete transfer",
	"viewAllTransfers": "View all transfers",
	"moveGame": "Transfer event",
	"checkInPlayerToMatch": "Check in athlete to event",
	"matchPrints": "Event prints",
	"viewReports": "View reports",
	"viewUsers": "View users",
	"editUsers": "Edit users",
	"overrideMatchFilters": "Override event filters",
	"viewAllJudges": "View all judges",
	"addJudge": "Add judge",
	"editJudge": "Edit judge",
	"deleteJudge": "Delete judge",
	"viewAllCoaches": "View all coaches",
	"addCoach": "Add coach",
	"editCoach": "Edit coach",
	"deleteCoach": "Delete coach",
	"viewAllTrainers": "View all part-time trainers",
	"addTrainer": "Add part-time trainer",
	"editTrainer": "Edit part-time trainer",
	"deleteTrainer": "Delete part-time trainer",
	"viewAllTrainingEntries": "View all training centers entries",
	"addTrainingEntry": "Add training center entry",
	"editTrainingEntry": "Edit training center entry",
	"deleteTrainingEntry": "Delete training center entry",
	"viewAllStaff": "View all staff",
	"addStaff": "Add staff",
	"editStaff": "Edit staff",
	"deleteStaff": "Delete staff",
	"viewAllTrainingCenters": "View Training Centers",
	"addTrainingCenter": "Add new training center",
	"editTrainingCenter": "Edit Training Center",
	"deleteTrainingCenter": "Delete Training Center",
	"ATHLETES_MATCH_CARDS": "Athletes match cards",
	"CERTIFICATES": "Certificates",
	"PLAYER_AGE": "Age",
	"AGE_FROM": "Age (From)",
	"AGE_TO": "Age (To)",
	"paraArchery": "Para Archery",
	"MATCH_CITY": "City",
	"MATCH_END_DATE": "Match End date",
	"ATHLETE_MATCH_ENTRY_CARDS": "Athlete Match Entry Cards",
	"BOARDS": "Boards",
	"ADD_SHOTS_VISUAL_ELIMINATIONS": "Eliminations Visual"
};


//////////////////
// WEBPACK FOOTER
// ./client/app/translations/en.json
// module id = 1085
// module chunks = 0